// Text constant
export const TITLE_PAGE = {
  catalog_top: 'カタログを探す',
  list_model_grade: 'モデル・グレード一覧',
  grade_detail: 'グレード詳細',
  body_type_selection: 'ボディタイプ選択',
  hybrid: 'ハイブリッドすべて',
  ev: 'EVすべて',
  plugin_hybrid: 'PHEVすべて',
  list_brand_selection: 'メーカー選択',
  model_top: 'モデルTOP',
  related_posts: '関連記事',
  car_catalog_list: '車種カタログ一覧',
}

export const TRANSITION_SOURCE = {
  catalog_search: 'catalog-search',
  latest_catalog: 'latest-catalog',
  pickup: 'pickup',
  condition_find: 'condition',
  newcar_search: 'newcar-search',
}

export const ANNOTATION_PATTERN = {
  pattern_a: '※革シートについては一部合皮を使用している場合があります。',
  pattern_b:
    '※2004年4月以降の発売車種につきましては、車両本体価格と消費\n税相当額（地方消費税額を含む）を含んだ総額表示（内税）となりま\nす。',
  pattern_c:
    '※燃費表示は10・15モード又は10モード、もしくはJC08モード、\nWLTCモードなど各測定方法に基づいた試験上の数値であり、実際の\n数値は走行条件などにより異なります。',
}

// goonetscheme or goonetschemebeta を付与しないとschemaとして機能しないため注意
export const SCHEMA_URL = {
  newcar_top: '://newCarSearchTop',
  used_car_detail: '://carDetail',
  favorite_usedcar_list: '://favorite?upperTab=car&lowerTab=used',
}

export const N2_AUTHORIZATION_TOKEN_PREFIX = 'Bearer '
